// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kMHX","delete":"styles_delete__2iIze","update":"styles_update__3XUgE","add":"styles_add__3-o3J"};